import { render, staticRenderFns } from "./ItemProductComponent.vue?vue&type=template&id=a486326c&lang=pug&"
import script from "./ItemProductComponent.vue?vue&type=script&lang=js&"
export * from "./ItemProductComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports